let text = $('#new_user_registration').attr('data-status');
if (text === 'Refused') {
    $('#refuse').addClass("disabled");
}

function update_organization(el$) {
    if (el$.val() === 'OM') {
        $('#div_id_organization_name').hide();
        $('#div_id_omcl').show();
        $('#id_organization_name').val($('#id_omcl').find('option:selected').text());
        $('#id_access_level option[value="AD"]').attr('disabled', false);
    } else {
        $('#div_id_omcl').hide();
        $('#id_omcl').val(null).trigger('change');
        $('#div_id_organization_name').show();
        if (el$.val() === 'ED') {
            $('#id_organization_name').val('EDQM');
            $('#id_access_level option[value="AD"]').attr('disabled', false);
        } else if ((el$.val() === 'OH')){
            $('#id_access_level option[value="AD"]').attr('disabled', false);
        } else {
            $('#id_access_level option[value="AD"]').prop('disabled', true).attr('selected', false);
        }
    }
}

let organization_type$ = $('#id_organization_type');
update_organization(organization_type$);
organization_type$.on('change', function(e) {
    update_organization($(this));
});

$('#id_omcl').on('change', function(e) {
   $('#id_organization_name').val($(this).find('option:selected').text());
});

// List
$(function() {
    $("#clear").click(function () {
        $('#form_search :input').val("");
        $('#form_search').submit()
    });
});
